import { useCallback, useEffect, useState } from 'react'
import PlainItemsSelectorBox from 'app/common/ui-next/_filter-compilations/plain-items-selector-box'
import { subscibeTo } from 'app/common/data-box-store'
import { sortClasses } from 'app/common/lib/sort'
import { prop } from 'ramda'
import { OrgsOrUserIDs, classesListFilter, classesListFilterSelection, defaultClassesListDataReceiver, defaultClassesListSelection, orgOrUserFilterSelection, orgsFilterSelection, schoolYearFilterSelection } from 'app/dataProviders/filter-items'


type Props = {
  id: string
  pending: boolean
}

const sortByTitle = sortClasses<{ title: string }>('down', prop('title'))

export const ClassesListFilter = ({ id, pending }: Props) => {
  const [isReady, setReady] = useState<boolean>(false)
  const [isReadyOrgs, setReadyOrgs] = useState<boolean>(false)
  const [filterVisibility, setFilterVisibility] = useState<boolean>(true)

  const handleOrgsFilter = useCallback((data: string[]) => {
    if (data.length === 1) {
      setReadyOrgs(true)
      return
    }
    classesListFilter.resetToDefault()
    setReadyOrgs(false)
  }, [])

  const handleSchoolYearFilter = useCallback((data: string[]) => {
    if (data.length === 1) {
      classesListFilter.addDataReceiver(
        defaultClassesListDataReceiver,
      )
      classesListFilter.dataReceive()
      classesListFilter.setStatusReady()
      setReady(true)
      return
    }
    classesListFilter.resetToDefault()
    setReady(false)
  }, [])

  const handleOrgOrUserFilter = useCallback((data: OrgsOrUserIDs) => {
    if (data === OrgsOrUserIDs.ByOrgs) {
      setFilterVisibility(true)
      return
    }
    classesListFilter.resetToDefault()
    setFilterVisibility(false)
    setReady(false)
  }, [])


  useEffect(() => {
    const orgsUnsubsribe = subscibeTo<string[]>(orgsFilterSelection.id, handleOrgsFilter)
    const schoolYearUnsubsribe = subscibeTo<string[]>(schoolYearFilterSelection.id, handleSchoolYearFilter)
    const orgOrUserUnsubsribe = subscibeTo<OrgsOrUserIDs>(orgOrUserFilterSelection.id, handleOrgOrUserFilter)

    return (() => {
      orgsUnsubsribe()
      schoolYearUnsubsribe()
      orgOrUserUnsubsribe()
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    filterVisibility && isReadyOrgs && isReady
    && <PlainItemsSelectorBox
      id={id}
      label="Класс"
      header="Выбор класса"
      dataBoxData={classesListFilter}
      dataBoxSelection={classesListFilterSelection}
      pleaseSelectText="Нет данных"
      selectedAllOnEmptySelection
      disabled={pending}
      multiple
      sortFunc={sortByTitle}
      defaultSelection={defaultClassesListSelection}
    />
  )
}
